import { Theme } from '@/entities/settings/models/types';

/**
 * Применяет тему к документу, добавляя или удаляя класс 'dark' на корневом элементе
 */
export const applyThemeToDocument = (theme: Theme): void => {
  if (typeof document !== 'undefined') {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }
};

const readThemeFromStorageKey = (key: string): Theme | null => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const theme = JSON.parse(raw)?.state?.theme;
    return typeof theme === 'string' && theme ? theme : null;
  } catch {
    return null;
  }
};

/**
 * Возвращает начальную тему: читает из нового ключа 'global-settings',
 * затем из legacy-ключа 'settings' (для плавной миграции), затем из системных настроек OS.
 * Также применяет тему к документу при инициализации.
 */
export const getInitialTheme = (): Theme => {
  if (typeof window !== 'undefined') {
    const savedTheme =
      readThemeFromStorageKey('global-settings') ?? readThemeFromStorageKey('settings');
    if (savedTheme) {
      applyThemeToDocument(savedTheme);
      return savedTheme;
    }
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      applyThemeToDocument('dark');
      return 'dark';
    }
  }
  applyThemeToDocument('light');
  return 'light';
};
